module.exports = __webpack_public_path__ + "img/43257dbabc2acb0ec9ec8ef99ee6e490.png";